import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import App from './App';
import { calendario } from './tema';
 // Cargar las claves desde el .env
const GOOGLE_CLIENT = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT}>
      {/* Todos los calendarios en español (ver calendario en tema.js) */}
      <LocalizationProvider {...calendario}>
        <App />
      </LocalizationProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);